import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17 * (props.wx ?? 1)}
    height={25 * (props.hx ?? 1)}
    viewBox="0 0 17 25"
    fill="none"
    className={props.className}
  >
    <mask
      id="normal_svg__a"
      width={17}
      height={25}
      x={0}
      y={0}
      fill="#000"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M0 0h17v25H0z" />
      <path d="M8.5 23.36c-1.284 0-4.625 1.69-6.554-.423C.4 21.243.97 17.171 2.079 14.43c.412-1.02.34-1.99.323-3.09-.082-5.23.966-10.06 2.74-10.064 1.217-.003.94 7.63 3.233 8.39.935.31 1.34-2.095 1.474-4.513.118-2.123-.528-3.354-.058-3.952.44-.56 2.083-.06 3.374 2.92.793 1.829 1.367 4.219 1.433 7.218.025 1.1-.09 2.072.323 3.09 1.108 2.742 1.68 6.815.133 8.508-1.93 2.114-5.27.422-6.554.422" />
    </mask>
    <path
      fill={props.fill}
      d="M8.5 23.36c-1.284 0-4.625 1.69-6.554-.423C.4 21.243.97 17.171 2.079 14.43c.412-1.02.34-1.99.323-3.09-.082-5.23.966-10.06 2.74-10.064 1.217-.003.94 7.63 3.233 8.39.935.31 1.34-2.095 1.474-4.513.118-2.123-.528-3.354-.058-3.952.44-.56 2.083-.06 3.374 2.92.793 1.829 1.367 4.219 1.433 7.218.025 1.1-.09 2.072.323 3.09 1.108 2.742 1.68 6.815.133 8.508-1.93 2.114-5.27.422-6.554.422"
    />
    <path
      stroke={props.stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.5 23.36c-1.284 0-4.625 1.69-6.554-.423C.4 21.243.97 17.171 2.079 14.43c.412-1.02.34-1.99.323-3.09-.082-5.23.966-10.06 2.74-10.064 1.217-.003.94 7.63 3.233 8.39.935.31 1.34-2.095 1.474-4.513.118-2.123-.528-3.354-.058-3.952.44-.56 2.083-.06 3.374 2.92.793 1.829 1.367 4.219 1.433 7.218.025 1.1-.09 2.072.323 3.09 1.108 2.742 1.68 6.815.133 8.508-1.93 2.114-5.27.422-6.554.422z"
      mask="url(#normal_svg__a)"
    />
  </svg>
);
export default SvgNormal;
